import React from 'react';
import { useState } from "react"
import {  FiImage, FiMic, FiPaperclip, FiSend, FiSmile } from 'react-icons/fi'
import messengerStore from '../../../../stores/useMessenger'
import { EmojiPicker } from './emojipicker';
 
const Send = () => {
  const {addMessage} = messengerStore(state=>state)

  const handleKeyPress = (event) => {
    if(event.key === 'Enter'){
      console.log('enter press here! ')
    }
  }

  const [message, setMessage] = useState('');

  const [updated, setUpdated] = useState('');

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      setUpdated(message);
      const object = {
          id:11,
          name:"You",
          me:true,
          avatar:"/images/avatars/Vector-12.png",
          date:"10:40 PM",
          messages:[
              message
          ],
      }
      addMessage(object, message) 
    }
  };

  return (
    <React.Fragment>
        <div class="send w-full px-4 flex flex-col dark:bg-[#141618]/20 bg-white/20 backdrop-blur-md 
            sticky bottom-0 left-0 right-0 z-30
        ">
          <div className=" left-0 top-0">
            {/** RECORD **/}
            <Typing /> 
          </div>
          <NewMessages />

          <div class="flex items-center my-4 xs:mt-0">
            <div
              class="-bg-[#1e2126] flex flex-col sm:flex-row sm:items-center w-full sm:px-6 rounded-md"
            >
              <div class="flex gap-3">
                <label htmlFor="file">
                  <input type="file" class="hidden" name="file" id="file" />
                  <FiPaperclip size={21}
                    class="stroke-gray-500 cursor-pointer"
                  />
                </label>
                <div
                  class="relative group"
                  x-data="{dropdown:false}"
                  // @click.outside="dropdown=false"
                >
                
                <EmojiPicker />

                </div>
                <FiMic size={21}
                  class="stroke-gray-500 cursor-pointer"
                />
                  <label htmlFor="image">
                  <input
                    type="file"
                    class="hidden"
                    name="image"
                    id="image"
                  />
                  <FiImage size={21}
                    class="cursor-pointer stroke-gray-500"
                  />
                </label>
              </div>
              <div class="flex gap-3 w-full items-center">
              <textarea
                type="text"
                id="message"
                name="message"
                value={message}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                //  -oninput="auto_height(this)"
                placeholder="Write a message"
                class="auto_height overflow-y-hidden p-3 border border-2 dark:border-gray-500 border-gray-200 rounded-full mx-3 outline-none bg-transparent w-full"
                rows="1"
              ></textarea>
              <div class="flex items-center gap-4 ml-4">
              
                <div class="group">
                  <div
                    class="group-hover:bg-gray-700 flex items-center justify-center p-2 rounded-full"
                  >
                    <FiSend size={21}
                      class="cursor-pointer stroke-gray-500 group-hover:stroke-gray-900"
                    />
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
    </React.Fragment>
  )
}

export default Send;
 
export const NewMessages = () => {
  return (
    <React.Fragment>
      <div class="flex w-full sm:justify-center justify-end">
          <div class="bg-blue-700 text-white p-1 rounded-full px-3 text-sm cursor-pointer flex items-center gap-1">
              <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="17" width="17" xmlns="http://www.w3.org/2000/svg"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>
              3 messages have
           </div>
      </div>
    </React.Fragment>
  )
}

export const Typing = () => {
  return (
    <React.Fragment>
      <div class="absolute -top-12 flex gap-2 items-end cursor-pointer mt-2">
          <img
            src="/images/avatars/Vector-13.png"
            class="h-8 w-8 rounded-full"
          />
          <div>
            <div
              class="flex gap-5 items-center typing bg-blue-600 rounded-xl p-3 pr-7 angle man"
            >
              <p class="font-medium">Typing</p>
              <div class="snippet" data-title="dot-typing">
                <div class="stage">
                  <div class="dot-typing"></div>
                </div>
              </div>
            </div>
            <div class="mt-2">Jake Doe</div>
          </div>
        </div>
    </React.Fragment>
  )
}
